import moment from 'moment';

export function dateTimeValueFromInputEvent(inputEvent: Event): string | null {
  const inputValue = (inputEvent.target as any).value;
  if (!inputValue) {
    return null;
  }
  return moment(inputValue).utc().format();
}

export function displayValueForDateTimeInput(dateTimeValue: Date | null): string {
  return dateTimeValue ? moment(dateTimeValue).format('YYYY-MM-DDTHH:mm') : '';
}
